import { render, staticRenderFns } from "./YearlyIndexWidget.vue?vue&type=template&id=6a015900&"
import script from "./YearlyIndexWidget.vue?vue&type=script&lang=js&"
export * from "./YearlyIndexWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports